
module.exports = {"attributes":{"enableBackground":"new 0 0 14 9","viewBox":"0 0 14 9","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"m1.7.6 5.3 5.3 5.3-5.3 1.4 1.4-6.7 6.7-6.7-6.7z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
